/**
 * @generated SignedSource<<34f289423d5ce25ca2331b5fd25d3d15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "NO_PERMISSION" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectSprintBacklogWrapper_viewer$data = {
  readonly id: string;
  readonly language: LANGUAGE | null;
  readonly actualPersonId: string | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly projectGroup: {
    readonly id: string;
    readonly companyProjectGroupId: number | null;
    readonly name: string | null;
    readonly color: string | null;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly demo: boolean | null;
          readonly stage: {
            readonly id: string;
            readonly name: string | null;
            readonly profile: PROJECT_STATUS | null;
          } | null;
          readonly companyProjectId: number | null;
          readonly taskLevels: number | null;
          readonly sprintTimeBox: boolean | null;
          readonly sprintLengthInDays: number | null;
          readonly useManualAllocations: boolean | null;
          readonly remainingAutoCalculated: boolean | null;
          readonly projectColor: string | null;
          readonly estimationUnit: string | null;
          readonly minutesPerEstimationPoint: number | null;
          readonly manualProgressOnProjectEnabled: boolean | null;
          readonly manualProgressOnPhasesEnabled: boolean | null;
          readonly manualProgressOnTasksEnabled: boolean | null;
          readonly budgetWork: number | null;
          readonly budgetType: BUDGET_TYPE | null;
          readonly tasks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly readOnly: {
                  readonly isReadOnly: boolean | null;
                } | null;
                readonly userCanDeleteTask: boolean | null;
                readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
                readonly sageIntacctId: string | null;
                readonly hasChildren: boolean | null;
                readonly name: string | null;
                readonly description: string | null;
                readonly highPriority: boolean | null;
                readonly companyTaskId: number | null;
                readonly estimateForecast: number | null;
                readonly timeLeft?: number | null;
                readonly timeRegistrations?: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly minutesRegistered: number | null;
                      readonly invoiced: boolean | null;
                      readonly person: {
                        readonly id: string;
                        readonly role: {
                          readonly id: string;
                        } | null;
                      } | null;
                    } | null;
                  } | null> | null;
                } | null;
                readonly progress?: number | null;
                readonly approved: boolean | null;
                readonly sortOrder: number | null;
                readonly blocked: boolean | null;
                readonly bug: boolean | null;
                readonly deadlineYear: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineDay: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly startFrom: string | null;
                readonly deadlineFrom: string | null;
                readonly hasDependency: boolean | null;
                readonly canStart: boolean | null;
                readonly canBeSetToDone: boolean | null;
                readonly subTaskCount: number | null;
                readonly latestUiUpdateAt: string | null;
                readonly hasLockedTime: boolean | null;
                readonly hasInvoicedTime: boolean | null;
                readonly favoured: boolean | null;
                readonly billable: boolean | null;
                readonly parentTaskId: string | null;
                readonly project: {
                  readonly id: string;
                  readonly demo: boolean | null;
                  readonly estimationUnit: string | null;
                  readonly minutesPerEstimationPoint: number | null;
                  readonly companyProjectId: number | null;
                  readonly projectEndYear: number | null;
                  readonly projectEndMonth: number | null;
                  readonly projectEndDay: number | null;
                  readonly projectColor: string | null;
                  readonly remainingAutoCalculated: boolean | null;
                  readonly name: string | null;
                  readonly stage: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly profile: PROJECT_STATUS | null;
                  } | null;
                  readonly projectGroupId: string | null;
                  readonly projectPerson: {
                    readonly role: {
                      readonly id: string;
                      readonly name: string | null;
                    } | null;
                  } | null;
                  readonly harvestProject: {
                    readonly id: string;
                  } | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                  readonly rateCard: {
                    readonly id: string;
                    readonly currency: string | null;
                    readonly disabledRoles: ReadonlyArray<{
                      readonly id: string;
                    } | null> | null;
                  } | null;
                  readonly useTaskHierarchy: boolean | null;
                  readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
                } | null;
                readonly taskLabels: ReadonlyArray<{
                  readonly id: string;
                  readonly label: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly color: string | null;
                  } | null;
                } | null> | null;
                readonly sprint: {
                  readonly id: string;
                  readonly endYear: number | null;
                  readonly endMonth: number | null;
                  readonly endDay: number | null;
                  readonly savedPerformance: number | null;
                  readonly name: string | null;
                  readonly projectGroupSprintId: string | null;
                  readonly isProjectGroupSprint: boolean | null;
                } | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly category: STATUS_CATEGORY | null;
                  readonly projectGroupStatusColumnId: number | null;
                } | null;
                readonly phase: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly deadlineYear: number | null;
                  readonly deadlineMonth: number | null;
                  readonly deadlineDay: number | null;
                } | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly assignedPersons: ReadonlyArray<{
                  readonly id: string;
                  readonly active: boolean | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly permissions: ReadonlyArray<string | null> | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                } | null> | null;
                readonly taskDismissedNotifications: {
                  readonly taskOverrunPredictionDismissed: boolean | null;
                } | null;
                readonly thisTaskDependsOn: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly type: DEPENDENCY_TYPE | null;
                      readonly thisDependsOnTask: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly deadlineYear: number | null;
                        readonly deadlineMonth: number | null;
                        readonly deadlineDay: number | null;
                        readonly startYear: number | null;
                        readonly startMonth: number | null;
                        readonly startDay: number | null;
                      } | null;
                    } | null;
                  } | null> | null;
                } | null;
                readonly owner: {
                  readonly id: string;
                  readonly permissions: ReadonlyArray<string | null> | null;
                } | null;
                readonly followers: ReadonlyArray<{
                  readonly id: string;
                  readonly permissions: ReadonlyArray<string | null> | null;
                } | null> | null;
                readonly parentTask: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly progressDetails: {
                  readonly progress: number | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly projectPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly person: {
                  readonly id: string;
                  readonly active: boolean | null;
                  readonly permissions: ReadonlyArray<string | null> | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly fullName: string | null;
                  readonly initials: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                } | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly sprints: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly projectGroupSprintId: string | null;
                readonly isProjectGroupSprint: boolean | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
                readonly endDay: number | null;
                readonly endMonth: number | null;
                readonly endYear: number | null;
                readonly description?: string | null;
                readonly savedPerformance: number | null;
                readonly hasUnfinishedTask: boolean | null;
                readonly integrations: {
                  readonly id: string;
                  readonly jiraId: string | null;
                  readonly adoId: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly phases: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null> | null;
          } | null;
          readonly statusColumnsV2: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly order: number | null;
                readonly name: string | null;
                readonly projectGroupStatusColumnId: number | null;
                readonly jiraStatusId: string | null;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null> | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly project: {
    readonly id: string;
    readonly name: string | null;
    readonly remainingAutoCalculated: boolean | null;
    readonly tasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly userCanDeleteTask: boolean | null;
          readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
          readonly hasChildren: boolean | null;
          readonly sageIntacctId: string | null;
          readonly name: string | null;
          readonly description: string | null;
          readonly highPriority: boolean | null;
          readonly companyTaskId: number | null;
          readonly estimateForecast: number | null;
          readonly timeLeft?: number | null;
          readonly timeRegistrations?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly minutesRegistered: number | null;
                readonly invoiced: boolean | null;
                readonly person: {
                  readonly id: string;
                  readonly role: {
                    readonly id: string;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly progress?: number | null;
          readonly approved: boolean | null;
          readonly sortOrder: number | null;
          readonly blocked: boolean | null;
          readonly bug: boolean | null;
          readonly deadlineYear: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineDay: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly startFrom: string | null;
          readonly deadlineFrom: string | null;
          readonly hasDependency: boolean | null;
          readonly canStart: boolean | null;
          readonly canBeSetToDone: boolean | null;
          readonly subTaskCount: number | null;
          readonly latestUiUpdateAt: string | null;
          readonly hasLockedTime: boolean | null;
          readonly hasInvoicedTime: boolean | null;
          readonly favoured: boolean | null;
          readonly billable: boolean | null;
          readonly parentTaskId: string | null;
          readonly taskLabels: ReadonlyArray<{
            readonly id: string;
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly sprint: {
            readonly id: string;
            readonly endYear: number | null;
            readonly endMonth: number | null;
            readonly endDay: number | null;
            readonly name: string | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly deadlineYear: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineDay: number | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
            readonly active: boolean | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly email: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly client: {
              readonly id: string;
            } | null;
          } | null> | null;
          readonly taskDismissedNotifications: {
            readonly taskOverrunPredictionDismissed: boolean | null;
          } | null;
          readonly project: {
            readonly id: string;
            readonly name: string | null;
            readonly demo: boolean | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
            readonly harvestProject: {
              readonly id: string;
            } | null;
            readonly projectPerson: {
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
            readonly remainingAutoCalculated: boolean | null;
            readonly companyProjectId: number | null;
            readonly estimationUnit: string | null;
            readonly minutesPerEstimationPoint: number | null;
            readonly projectStartYear: number | null;
            readonly projectStartMonth: number | null;
            readonly projectStartDay: number | null;
            readonly projectEndYear: number | null;
            readonly projectEndMonth: number | null;
            readonly projectEndDay: number | null;
            readonly projectColor: string | null;
            readonly stage: {
              readonly id: string;
              readonly name: string | null;
              readonly profile: PROJECT_STATUS | null;
            } | null;
            readonly useTaskHierarchy: boolean | null;
          } | null;
          readonly thisTaskDependsOn: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly type: DEPENDENCY_TYPE | null;
                readonly thisDependsOnTask: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly deadlineYear: number | null;
                  readonly deadlineMonth: number | null;
                  readonly deadlineDay: number | null;
                  readonly startYear: number | null;
                  readonly startMonth: number | null;
                  readonly startDay: number | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly owner: {
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null> | null;
          readonly parentTask: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly progressDetails: {
            readonly progress: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly projectPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly person: {
            readonly id: string;
            readonly active: boolean | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly initials: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
            readonly client: {
              readonly id: string;
            } | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly sprints: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly timeLeft: number | null;
          readonly forecast: number | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly endDay: number | null;
          readonly endMonth: number | null;
          readonly endYear: number | null;
          readonly description?: string | null;
          readonly savedPerformance: number | null;
          readonly hasUnfinishedTask: boolean | null;
          readonly sprintPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly availableMinutes?: number | null;
                readonly scheduledMinutes?: number | null;
                readonly taskAvailableMinutes?: number | null;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly integrations: {
            readonly id: string;
            readonly jiraId: string | null;
            readonly adoId: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly phases: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly statusColumnsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly order: number | null;
          readonly name: string | null;
          readonly projectGroupStatusColumnId: number | null;
          readonly jiraStatusId: string | null;
          readonly category: STATUS_CATEGORY | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly company: {
    readonly id: string;
    readonly backendId: number | null;
    readonly name: string | null;
    readonly currency: string | null;
    readonly harvestEnabled: boolean | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly isUsingProjectAllocation: boolean | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
          readonly category: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"LabelDropdownJS_labels">;
        } | null;
      } | null> | null;
    } | null;
    readonly clients: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly logoId: string | null;
          readonly logoDefaultId: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly teamPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"TeamDropdown_teams">;
      } | null> | null;
    } | null;
    readonly monday: number | null;
    readonly tuesday: number | null;
    readonly wednesday: number | null;
    readonly thursday: number | null;
    readonly friday: number | null;
    readonly saturday: number | null;
    readonly sunday: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"genericTaskContextMenu_company">;
  } | null;
  readonly " $fragmentType": "ProjectSprintBacklogWrapper_viewer";
};
export type ProjectSprintBacklogWrapper_viewer$key = {
  readonly " $data"?: ProjectSprintBacklogWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSprintBacklogWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v9 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DeprecatedProjectIndicatorJS_project"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "backlog",
    "value": true
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v25 = [
  (v1/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v30 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v24/*: any*/),
    {
      "alias": "timeRegistrations",
      "args": null,
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_timeRegistrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": (v25/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v26/*: any*/)
              ],
              "storageKey": null
            },
            (v27/*: any*/)
          ],
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    (v29/*: any*/)
  ]
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDependency",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canStart",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeSetToDone",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v56 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v56/*: any*/),
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "personId",
      "variableName": "personId"
    }
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v57/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "savedPerformance",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupSprintId",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProjectGroupSprint",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskDismissedNotifications",
  "kind": "LinkedField",
  "name": "taskDismissedNotifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskOverrunPredictionDismissed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v80 = {
  "alias": "thisTaskDependsOn",
  "args": null,
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "__Task_thisTaskDependsOn_connection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "thisDependsOnTask",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v35/*: any*/),
                (v36/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/)
              ],
              "storageKey": null
            },
            (v26/*: any*/)
          ],
          "storageKey": null
        },
        (v27/*: any*/)
      ],
      "storageKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v81 = [
  (v1/*: any*/),
  (v78/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v81/*: any*/),
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v81/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": (v56/*: any*/),
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskProgress",
  "kind": "LinkedField",
  "name": "progressDetails",
  "plural": false,
  "selections": [
    (v29/*: any*/)
  ],
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v73/*: any*/),
                (v78/*: any*/),
                (v74/*: any*/),
                (v75/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "initials",
                  "storageKey": null
                },
                (v76/*: any*/),
                (v77/*: any*/),
                (v57/*: any*/),
                (v60/*: any*/)
              ],
              "storageKey": null
            },
            (v57/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(first:1000000)"
},
v87 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v20/*: any*/)
  ]
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnfinishedTask",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "SprintIntegrationsType",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adoId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1000
    }
  ],
  "concreteType": "PhaseTypeConnection",
  "kind": "LinkedField",
  "name": "phases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v56/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "phases(first:1000)"
},
v91 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "StatusColumnV2TypeConnection",
  "kind": "LinkedField",
  "name": "statusColumnsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2TypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusColumnV2",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            (v2/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jiraStatusId",
              "storageKey": null
            },
            (v70/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "statusColumnsV2(first:1000000)"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchLazyData"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "groupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "tasks"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "sprints"
        ]
      }
    ]
  },
  "name": "ProjectSprintBacklogWrapper_viewer",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "groupId"
        }
      ],
      "concreteType": "ProjectGroupType",
      "kind": "LinkedField",
      "name": "projectGroup",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectGroupId",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "ProjectTypeConnection",
          "kind": "LinkedField",
          "name": "projects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "taskLevels",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sprintTimeBox",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sprintLengthInDays",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "useManualAllocations",
                      "storageKey": null
                    },
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "manualProgressOnProjectEnabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "manualProgressOnPhasesEnabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "manualProgressOnTasksEnabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "budgetWork",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "budgetType",
                      "storageKey": null
                    },
                    {
                      "alias": "tasks",
                      "args": (v14/*: any*/),
                      "concreteType": "TaskTypeConnection",
                      "kind": "LinkedField",
                      "name": "__Project_tasks_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TaskTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Task",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v15/*: any*/),
                                (v16/*: any*/),
                                (v17/*: any*/),
                                (v18/*: any*/),
                                (v19/*: any*/),
                                (v2/*: any*/),
                                (v20/*: any*/),
                                (v21/*: any*/),
                                (v22/*: any*/),
                                (v23/*: any*/),
                                (v30/*: any*/),
                                (v31/*: any*/),
                                (v32/*: any*/),
                                (v33/*: any*/),
                                (v34/*: any*/),
                                (v35/*: any*/),
                                (v36/*: any*/),
                                (v37/*: any*/),
                                (v38/*: any*/),
                                (v39/*: any*/),
                                (v40/*: any*/),
                                (v41/*: any*/),
                                (v42/*: any*/),
                                (v43/*: any*/),
                                (v44/*: any*/),
                                (v45/*: any*/),
                                (v46/*: any*/),
                                (v47/*: any*/),
                                (v48/*: any*/),
                                (v49/*: any*/),
                                (v50/*: any*/),
                                (v51/*: any*/),
                                (v52/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ProjectType",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v6/*: any*/),
                                    (v12/*: any*/),
                                    (v13/*: any*/),
                                    (v8/*: any*/),
                                    (v9/*: any*/),
                                    (v53/*: any*/),
                                    (v54/*: any*/),
                                    (v55/*: any*/),
                                    (v11/*: any*/),
                                    (v10/*: any*/),
                                    (v2/*: any*/),
                                    (v7/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "projectGroupId",
                                      "storageKey": null
                                    },
                                    (v58/*: any*/),
                                    (v59/*: any*/),
                                    (v60/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "RateCard",
                                      "kind": "LinkedField",
                                      "name": "rateCard",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        (v61/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Role",
                                          "kind": "LinkedField",
                                          "name": "disabledRoles",
                                          "plural": true,
                                          "selections": (v25/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    (v62/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v63/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Sprint",
                                  "kind": "LinkedField",
                                  "name": "sprint",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v64/*: any*/),
                                    (v65/*: any*/),
                                    (v66/*: any*/),
                                    (v67/*: any*/),
                                    (v2/*: any*/),
                                    (v68/*: any*/),
                                    (v69/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "StatusColumnV2",
                                  "kind": "LinkedField",
                                  "name": "statusColumnV2",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v2/*: any*/),
                                    (v70/*: any*/),
                                    (v71/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v72/*: any*/),
                                (v57/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "assignedPersons",
                                  "plural": true,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v73/*: any*/),
                                    (v74/*: any*/),
                                    (v75/*: any*/),
                                    (v76/*: any*/),
                                    (v77/*: any*/),
                                    (v78/*: any*/),
                                    (v60/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v79/*: any*/),
                                (v80/*: any*/),
                                (v82/*: any*/),
                                (v83/*: any*/),
                                (v84/*: any*/),
                                (v85/*: any*/),
                                (v26/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v27/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v28/*: any*/)
                      ],
                      "storageKey": "__Project_tasks_connection(backlog:true)"
                    },
                    (v86/*: any*/),
                    {
                      "alias": "sprints",
                      "args": null,
                      "concreteType": "SprintTypeConnection",
                      "kind": "LinkedField",
                      "name": "__Project_sprints_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SprintTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Sprint",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v2/*: any*/),
                                (v68/*: any*/),
                                (v69/*: any*/),
                                (v40/*: any*/),
                                (v39/*: any*/),
                                (v38/*: any*/),
                                (v66/*: any*/),
                                (v65/*: any*/),
                                (v64/*: any*/),
                                (v87/*: any*/),
                                (v67/*: any*/),
                                (v88/*: any*/),
                                (v89/*: any*/),
                                (v26/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v27/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v28/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v90/*: any*/),
                    (v91/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "projects(first:1000000)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v10/*: any*/),
        {
          "alias": "tasks",
          "args": (v14/*: any*/),
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_tasks_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v19/*: any*/),
                    (v18/*: any*/),
                    (v2/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/),
                    (v23/*: any*/),
                    (v30/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v35/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v38/*: any*/),
                    (v39/*: any*/),
                    (v40/*: any*/),
                    (v41/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    (v45/*: any*/),
                    (v46/*: any*/),
                    (v47/*: any*/),
                    (v48/*: any*/),
                    (v49/*: any*/),
                    (v50/*: any*/),
                    (v51/*: any*/),
                    (v52/*: any*/),
                    (v63/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sprint",
                      "kind": "LinkedField",
                      "name": "sprint",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v64/*: any*/),
                        (v65/*: any*/),
                        (v66/*: any*/),
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnV2",
                      "kind": "LinkedField",
                      "name": "statusColumnV2",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v70/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v72/*: any*/),
                    (v57/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "assignedPersons",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        (v73/*: any*/),
                        (v74/*: any*/),
                        (v75/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        (v76/*: any*/),
                        (v77/*: any*/),
                        (v78/*: any*/),
                        (v60/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v79/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v6/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Client",
                          "kind": "LinkedField",
                          "name": "client",
                          "plural": false,
                          "selections": (v56/*: any*/),
                          "storageKey": null
                        },
                        (v59/*: any*/),
                        (v58/*: any*/),
                        (v10/*: any*/),
                        (v8/*: any*/),
                        (v12/*: any*/),
                        (v13/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectStartYear",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectStartMonth",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectStartDay",
                          "storageKey": null
                        },
                        (v53/*: any*/),
                        (v54/*: any*/),
                        (v55/*: any*/),
                        (v11/*: any*/),
                        (v7/*: any*/),
                        (v62/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v80/*: any*/),
                    (v82/*: any*/),
                    (v83/*: any*/),
                    (v84/*: any*/),
                    (v85/*: any*/),
                    (v26/*: any*/)
                  ],
                  "storageKey": null
                },
                (v27/*: any*/)
              ],
              "storageKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": "__Project_tasks_connection(backlog:true)"
        },
        (v86/*: any*/),
        {
          "alias": "sprints",
          "args": null,
          "concreteType": "SprintTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_sprints_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v24/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecast",
                      "storageKey": null
                    },
                    (v40/*: any*/),
                    (v39/*: any*/),
                    (v38/*: any*/),
                    (v66/*: any*/),
                    (v65/*: any*/),
                    (v64/*: any*/),
                    (v87/*: any*/),
                    (v67/*: any*/),
                    (v88/*: any*/),
                    {
                      "alias": null,
                      "args": (v5/*: any*/),
                      "concreteType": "SprintPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "sprintPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SprintPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SprintPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "condition": "fetchLazyData",
                                  "kind": "Condition",
                                  "passingValue": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "availableMinutes",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "scheduledMinutes",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "taskAvailableMinutes",
                                      "storageKey": null
                                    }
                                  ]
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v74/*: any*/),
                                    (v75/*: any*/),
                                    (v76/*: any*/),
                                    (v77/*: any*/),
                                    (v57/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "sprintPersons(first:1000000)"
                    },
                    (v89/*: any*/),
                    (v26/*: any*/)
                  ],
                  "storageKey": null
                },
                (v27/*: any*/)
              ],
              "storageKey": null
            },
            (v28/*: any*/)
          ],
          "storageKey": null
        },
        (v90/*: any*/),
        (v91/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "genericTaskContextMenu_company"
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backendId",
          "storageKey": null
        },
        (v2/*: any*/),
        (v61/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v56/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "roles(first:1000000)"
        },
        {
          "alias": null,
          "args": [
            (v4/*: any*/),
            {
              "kind": "Literal",
              "name": "labelType",
              "value": "TASK"
            }
          ],
          "concreteType": "LabelTypeConnection",
          "kind": "LinkedField",
          "name": "labels",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LabelTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LabelCategory",
                      "kind": "LinkedField",
                      "name": "category",
                      "plural": false,
                      "selections": (v56/*: any*/),
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "LabelDropdownJS_labels"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "labels(first:1000000,labelType:\"TASK\")"
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "ClientTypeConnection",
          "kind": "LinkedField",
          "name": "clients",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Client",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "logoId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "logoDefaultId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "clients(first:1000000)"
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "TeamTypeConnection",
          "kind": "LinkedField",
          "name": "teams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamDropdown_teams"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": (v5/*: any*/),
                      "concreteType": "TeamPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "teamPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TeamPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TeamPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": (v25/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "teamPersons(first:1000000)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "teams(first:1000000)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tuesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wednesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thursday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "friday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saturday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sunday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a88fe50b2e857060009b8d042eeb2ed7";

export default node;
